import { render, staticRenderFns } from "./CooperateMode.vue?vue&type=template&id=6b2198d6&scoped=true"
import script from "./CooperateMode.vue?vue&type=script&lang=js"
export * from "./CooperateMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2198d6",
  null
  
)

export default component.exports